import { render, staticRenderFns } from "./_ExcursionInfo.vue?vue&type=template&id=07e0dee7"
import script from "./_ExcursionInfo.vue?vue&type=script&lang=js"
export * from "./_ExcursionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports